import React, { useState } from 'react';
import { Box, Container, Grid, Typography, Link, IconButton, Stack, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { Twitter as TwitterIcon, LinkedIn as LinkedInIcon, Facebook as FacebookIcon, Instagram as InstagramIcon, AppShortcut as AppIcon } from '@mui/icons-material';
import PWASettings from './PWASettings';

/**
 * Footer component for the application
 */
const Footer = () => {
  const [pwaSettingsOpen, setPwaSettingsOpen] = useState(false);

  const handleOpenPwaSettings = () => {
    setPwaSettingsOpen(true);
  };

  const handleClosePwaSettings = () => {
    setPwaSettingsOpen(false);
  };
  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        py: 6,
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Laprecio
            </Typography>
            <Typography variant="subtitle1" color="primary" fontWeight="bold" gutterBottom>
              Global Trade, Digital Trust
            </Typography>
            <Typography variant="body2" color="text.secondary">
              A secure, transparent, and efficient platform for trading minerals globally with full compliance and traceability.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Quick Links
            </Typography>
            <Link component={RouterLink} to="/about" color="text.secondary" display="block" sx={{ mb: 1 }}>
              About Us
            </Link>
            <Link component={RouterLink} to="/contact" color="text.secondary" display="block" sx={{ mb: 1 }}>
              Contact Us
            </Link>
            <Link component={RouterLink} to="/faq" color="text.secondary" display="block" sx={{ mb: 1 }}>
              FAQ
            </Link>
            <Link component={RouterLink} to="/terms" color="text.secondary" display="block">
              Terms of Service
            </Link>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Contact Us
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              Email: hello@laprecio.com
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              First Floor, 85 Great Portland St<br />
              London W1W 7LT, UK
            </Typography>

            <Typography variant="h6" color="text.primary" gutterBottom>
              Follow Us
            </Typography>
            <Stack direction="row" spacing={1}>
              <IconButton
                aria-label="Twitter"
                component="a"
                href="https://twitter.com/laprecio"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: '#1DA1F2' }}
              >
                <TwitterIcon />
              </IconButton>
              <IconButton
                aria-label="LinkedIn"
                component="a"
                href="https://www.linkedin.com/company/laprecio"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: '#0077B5' }}
              >
                <LinkedInIcon />
              </IconButton>
              <IconButton
                aria-label="Facebook"
                component="a"
                href="https://www.facebook.com/laprecio"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: '#1877F2' }}
              >
                <FacebookIcon />
              </IconButton>
              <IconButton
                aria-label="Instagram"
                component="a"
                href="https://www.instagram.com/laprecio_official"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: '#E4405F' }}
              >
                <InstagramIcon />
              </IconButton>
            </Stack>
          </Grid>
        </Grid>
        <Box mt={5}>
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
            <Button
              variant="outlined"
              size="small"
              startIcon={<AppIcon />}
              onClick={handleOpenPwaSettings}
              sx={{ borderRadius: 50, fontSize: '0.75rem' }}
            >
              App Settings
            </Button>
          </Box>
          <Typography variant="body2" color="text.secondary" align="center">
            {'© '}
            {new Date().getFullYear()}
            {' Laprecio. All rights reserved.'}
          </Typography>
        </Box>

        {/* PWA Settings Dialog */}
        <PWASettings open={pwaSettingsOpen} onClose={handleClosePwaSettings} />
      </Container>
    </Box>
  );
};

export default Footer;
